export default "__VITE_ASSET__BHI2jnUL__"